import { makeCRUDSlice } from '@redux/crudCreator';
import { MODEL_NAME, bannersActions } from './actions';

const slice = makeCRUDSlice(MODEL_NAME, bannersActions);

export default slice.reducer;
